var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"quickbar-button"},[_c('div',{staticClass:"button-container",class:{ 'active' : _vm.active },on:{"click":_vm.onClick}},[(_vm.icon)?_c('font-awesome-icon',{attrs:{"icon":_vm.icon,"size":"lg","fixed-width":""}}):_c('span',[_vm._v(_vm._s(_vm.text))])],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }